<template>
  <div class="page">
    <!-- <div class="title">今泉涞用户服务协议</div> -->
    <div v-html="detail"></div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        detail: ''
      }
    },
    methods: {
      GetuserAgreement () {
        this.$Get('Common.userAgreement').then((res) => {
          this.detail = res.data.agreement
        })
      }
    },
    mounted () {
      this.GetuserAgreement()
    }
  }
</script>

<style lang="less" scoped>
  .page {
    .p(.3rem);
    .title {
      .fz(.34rem);
      .c(#333);
      .mb(.4rem);
      font-weight: bold;
      text-align: center;
    }
    p {
      .fz(.28rem);
      .c(#666);
      .mb(.22rem);
      .lh(1.5);
    }
  }
</style>
